import { useCallback, useEffect, useState } from "react";
import { adminApi, feedbackApi } from "../../../api";
import type { AdminUser } from "../types";

export function useAdminPageData() {
  const [users, setUsers] = useState<AdminUser[]>([]);
  const [feedbackOpenCount, setFeedbackOpenCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const loadUsers = useCallback(async () => {
    const response = await adminApi.listUsers();
    setUsers(Array.isArray(response.data) ? response.data : []);
  }, []);

  const loadFeedbackOpenCount = useCallback(async () => {
    try {
      const response = await feedbackApi.listAdmin("open");
      setFeedbackOpenCount(response.data.open_count ?? 0);
    } catch {
      setFeedbackOpenCount(0);
    }
  }, []);

  const handleFeedbackOpenCountChange = useCallback((count: number) => {
    setFeedbackOpenCount(count);
  }, []);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      loadUsers().finally(() => setLoading(false));
      void loadFeedbackOpenCount();
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [loadFeedbackOpenCount, loadUsers]);

  return {
    users,
    feedbackOpenCount,
    loading,
    loadUsers,
    handleFeedbackOpenCountChange,
  };
}
